import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {toJS} from 'mobx'
import firebase from '../firebase'
import * as helpers from '../lib/HelperFunctions'
import moment from 'moment'
// import 'moment/locale/da'
import Lightbox from 'react-image-lightbox'
import {Nav, NavItem, Tab, Glyphicon, Panel, ControlLabel, Row, Col} from 'react-bootstrap'
import OneLineTextField from '../components/OneLineTextField'
// import IdeaSketchField from '../components/IdeaSketchField'
import IdeaDueDate from '../components/IdeaDueDate'
import IdeaImageField from '../components/IdeaImageField'
// import IdeaVideoField from '../components/IdeaVideoField'
import IdeaAttachmentField from '../components/IdeaAttachmentField'
import RichTextField from '../components/RichTextField'
import PoorTextField from '../components/PoorTextField'
import IdeaSharingField from '../components/IdeaSharingField'
import VideoModal from '../components/VideoModal'
import ViabilityContainer from '../containers/ViabilityContainer'
import ToolTip from '../components/ToolTip.js'
import Logger from '../stores/Logger'
import '../containers/css/IdeaPage.css'
import IdeaRatingField from '../components/IdeaRatingField'
import IdeaStage from '../components/IdeaStage'
import '../components/css/react-tagsinput.css'
import TimelineContainer from '../containers/TimelineContainer'
import RecommendationLabel from '../components/RecommendationLabel'
import Select from 'react-select'
import SelectStyle from '../containers/css/SelectStyleIdeaPage.css'
import 'react-select/dist/react-select.css'
import CommentSection from '../components/CommentSection'
import ChatEntry from '../components/ChatEntry'
import {shareMode} from '../stores/PrefStore'

class IdeaPage extends Component {
    constructor(props) {
        super(props)
        this.handleDelete = this.handleDelete.bind(this)
        this.nextSlide = this.nextSlide.bind(this)
        this.onDeleteSketch = this.onDeleteSketch.bind(this)
        this.previousSlide = this.previousSlide.bind(this)
        this.checkToolContent = this.checkToolContent.bind(this)
        this.checkTimelineContent =  this.checkTimelineContent.bind(this)
        this.checkViabilityContent =  this.checkViabilityContent.bind(this)
        this.storeIdea = this.storeIdea.bind(this)
        this.state = {
            existingIdeaKey: undefined,
            isOpenImage: false,
            longCharWarning: false,
            isOpenIdea: false,
            isOpenNeed: false,
            defaultStages: null,
            loadedTeamTags: [],
            loadedTeamStages: [],
            loadedTeamTools: [],
            imageId: 0,
            className: 'ideaPageCommentSection',
            isFirstime: true,
        }
    }
    componentWillMount(){
        const {stores} = this.props
        const {store, authStore, messageStore, prefStore, toolStore} = stores
        if (this.props.params.ideaKey){
            let thing = this
            let noTeamStages = toolStore.defaultStages.toJSON()
            let noTeamTools = toolStore.defaultTools.toJSON()
            let noTeamTags = []
            if(this.props.params.ideaKey === 'new'){
                this.unloadAndCreateNewIdea()
                const authUser = authStore.authUser()
                prefStore.findTeam(authUser.uid).then(() => {
                    if(prefStore.defaultIdeaTags.length > 0){
                        this.setState({
                            loadedTeamTags: prefStore.defaultIdeaTags,
                        })
                    } else {
                        firebase.database().ref().child('tags').once('value',tagsSnap => {
                            if(tagsSnap.exists()){
                                noTeamTags = tagsSnap.val()
                                this.setState({
                                    loadedTeamTags: noTeamTags,
                                })
                            }
                        })
                    }

                    ///////////////////////

                    if (prefStore.defaultIdeaStages.length > 0){
                        this.setState({
                            loadedTeamStages: prefStore.defaultIdeaStages,
                        })
                    } else {
                        firebase.database().ref().child('stages').once('value',stagesSnap => {
                            if(stagesSnap.exists()){
                                noTeamStages = stagesSnap.val()
                                this.setState({
                                    loadedTeamStages: noTeamStages,
                                })
                            }
                        })
                    }

                    ////////////////////////
                    if (prefStore.defaultIdeaTools.length > 0){
                        this.setState({
                            loadedTeamTools: prefStore.defaultIdeaTools,
                        })
                    } else {
                        firebase.database().ref().child('tools').once('value',toolsSnap => {
                            if(toolsSnap.exists()){
                                noTeamTools = toolsSnap.val()
                                this.setState({
                                    loadedTeamTools: noTeamTools,
                                })
                            }
                        })
                    }

                    if(prefStore.autoShare === 0){
                        store.infoAlert = "Your idea will be shared with your team's admins"
                    } else if (prefStore.autoShare === 1){
                        store.infoAlert = 'Your idea will be shared with your team'
                    } else if (prefStore.autoShare === 2){
                        store.infoAlert = 'Your idea will not automatically be public to your team'
                    }
                })
                window.setTimeout(() => {
                    store.infoAlert = undefined
                }, 5000)
            }else{
                this.unwatchAuth = authStore.watchAuth(user => {
                    if (user){
                        firebase.database().ref().child('ideas/'+thing.props.params.ideaKey).once('value').then(ideaSnap => {
                            if(ideaSnap.exists()){
                                store.loadIdeaWithKey(thing.props.params.ideaKey)
                                thing.setState({existingIdeaKey: thing.props.params.ideaKey})
                            } else {

                            }
                        }).catch(err => {
                            const { routingStore } = this.props.stores
                            const { push } = routingStore
                            Logger.trackEvent('newIdeaStarted')
                            push('/idea/new')
                        })
                        //store.loadIdeaWithKey(thing.props.params.ideaKey)

                        prefStore.loadTeamPrefs(thing.props.params.ideaKey).then(() => {

                            if(prefStore.defaultIdeaTags.length > 0){
                                this.setState({
                                    loadedTeamTags: prefStore.defaultIdeaTags,
                                })
                            } else {
                                firebase.database().ref().child('tags').once('value',tagsSnap => {
                                    if(tagsSnap.exists()){
                                        noTeamTags = tagsSnap.val()
                                        this.setState({
                                            loadedTeamTags: noTeamTags,
                                        })
                                    }
                                })
                            }

                            ///////////////////////

                            if (prefStore.defaultIdeaStages.length > 0){
                                this.setState({
                                    loadedTeamStages: prefStore.defaultIdeaStages.toJSON(),
                                })
                            } else {
                                firebase.database().ref().child('stages').once('value',stagesSnap => {
                                    if(stagesSnap.exists()){
                                        noTeamStages = stagesSnap.val()
                                        this.setState({
                                            loadedTeamStages: noTeamStages,
                                        })
                                    }
                                })
                            }

                            ////////////////////////

                            if (prefStore.defaultIdeaTools.length > 0){
                                this.setState({
                                    loadedTeamTools: prefStore.defaultIdeaTools,
                                })
                            } else {
                                firebase.database().ref().child('tools').once('value',toolsSnap => {
                                    if(toolsSnap.exists()){
                                        noTeamTools = toolsSnap.val()
                                        this.setState({
                                            loadedTeamTools: noTeamTools,
                                        })
                                    }
                                })
                            }
                        })
                        messageStore.loadMessagesForIdea(thing.props.params.ideaKey)
                        store.loadSketchForIdea(thing.props.params.ideaKey)
                    }
                }, error => {
                    console.log('watchAuth error: '+JSON.stringify(error))
                })
            }
        }
    }
    componentDidMount(){
        this.focusOnTitle()
    }
    componentWillUpdate(){
        const {stores} = this.props
        const {store, authStore, teamStore} = stores
        const {theIdea} = store
        /* const {push} = routingStore */
        let team = authStore.auth.primaryTeam
        var theUser = authStore.authUser()
        /* let isFound = false */
        if (theUser !== undefined){
            if(team !== undefined && theIdea !== undefined){
                if((team.hasOwnProperty('autoShare')) && (team.hasOwnProperty('key') && theIdea.hasOwnProperty('teamId') && team.key === theIdea.teamId)){
                    if (team.autoShare === shareMode.shareWithAdmins && store.newIdea === true && theIdea.hasOwnProperty('lastUpdated')){
                        store.newIdea = false
                        teamStore.addReferenceOfTheIdeaToUsers(team.key, this.state.existingIdeaKey, team.admin, theIdea)
                    } else if (team.autoShare === shareMode.shareWithTeam && store.newIdea === true && theIdea.hasOwnProperty('lastUpdated')){
                        store.newIdea = false
                        teamStore.addReferenceOfTheIdea(team.key, this.state.existingIdeaKey)
                    }
                }
                /* if(team.hasOwnProperty('key') && team.key && theIdea.hasOwnProperty('teamId') && theIdea.teamId){
                    if (team.key !== theIdea.teamId){
                        authStore.findTeam(theIdea.teamId, theUser.uid).then((team) => {
                            if(team !== undefined){
                                Object.keys(team.val().members).forEach((member, index) => {
                                    if (member === theUser.uid){
                                        isFound = true
                                    }
                                })
                                if (isFound === true && authStore.auth.manuallyChangedTeams === false){
                                console.log('IF')
                                //let inIdeaPage = true
                                //authStore.changeTeam(theIdea.teamId, inIdeaPage)
                                //store.subscribeToAllIdeas()
                                } else if (authStore.auth.manuallyChangedTeams === true){
                                    console.log('ELSE')
                                    store.manuallyChangedTeams = false
                                    //store.subscribeToAllIdeas()
                                    //push('/ideas')
                                }
                            }
                        })
                    }
                } */
            }
        }
    }
    componentDidUpdate(){
        this.scrollToBottom()
    }
    componentWillReceiveProps(nextProps){
        //This is called when a new idea is saved and redirected to own url /idea/<ideaKey>
        const {stores, params} = nextProps
        const {store, messageStore} = stores
        const {ideaKey} = params
        if(ideaKey){
            if(ideaKey === 'new'){
                this.unloadAndCreateNewIdea()
            }else{
                if(this.state.existingIdeaKey !== ideaKey){
                    this.setState({existingIdeaKey: ideaKey})
                }
                firebase.database().ref().child('ideas/'+ideaKey).once('value').then(ideaSnap => {
                    if(ideaSnap.exists()){
                        store.loadIdeaWithKey(ideaKey)
                        messageStore.loadMessagesForIdea(ideaKey)
                        store.loadSketchForIdea(ideaKey)
                    } else {
                        const { routingStore } = this.props.stores
                        const { push } = routingStore
                        Logger.trackEvent('newIdeaStarted')
                        push('/idea/new')
                    }
                }).catch(err => {
                    const { routingStore } = this.props.stores
                    const { push } = routingStore
                    Logger.trackEvent('newIdeaStarted')
                    push('/idea/new')
                })

            }
        }
    }
    componentWillUnmount() {
        // console.log('componentWillUnmount')
        const {stores} = this.props
        const {store, authStore, messageStore} = stores
        let theUser = authStore.authUser()
        if (this.state.existingIdeaKey) {
            if(store.theIdea && theUser){
                if(store.theIdea.hasOwnProperty('lastUpdated')){
                    store.newIdea = false
                }
                let theUser = authStore.authUser()
                let isOwner = (theUser.email === store.theIdea.owner) ? true : false
                if(!store.theIdea.hasOwnProperty('lastUpdated') && isOwner){
                    //NEW idea, never edited, so lets remove it.
                    console.log('deleting EMPTY idea!',this.state.existingIdeaKey)
                    Logger.trackEvent('deletingEmptyNewIdea')
                    store.deleteIdea(this.state.existingIdeaKey)
                }
            }
            messageStore.unloadMessages(this.state.existingIdeaKey)
            store.unloadSketches(this.state.existingIdeaKey)
            store.unloadIdea(this.state.existingIdeaKey)
        }
        if (this.unwatchAuth) {
            this.unwatchAuth()
            this.unwatchAuth = null
        }
    }
    doClose() {
        // console.log('doClose')
        const {stores} = this.props
        const {routingStore} = stores

        window.onpopstate = null

        const { goBack } = routingStore
        goBack()
    }
    onBackButtonEvent(e) {
        console.log('handling back button press')
        // this.doClose()
    }
    unloadAndCreateNewIdea() {
        const {stores} = this.props
        const {authStore, routingStore, store, messageStore, prefStore} = stores
        const authUser = authStore.authUser()
        prefStore.findTeam(authUser.uid).then(() => {
            if(prefStore.autoShare === shareMode.shareWithAdmins && Object.keys(prefStore.teamAdmins).length > 1 && Object.keys(prefStore.teamAdmins)[0] !== authUser.uid){
                store.infoAlert = "Your idea will be shared with your team's admins"
            } else if (prefStore.autoShare === shareMode.shareWithAdmins && Object.keys(prefStore.teamAdmins).length === 1 && Object.keys(prefStore.teamAdmins)[0] !== authUser.uid){
                store.infoAlert = "Your idea will be shared with your team's admin"
            } else if (prefStore.autoShare === shareMode.shareWithTeam){
                store.infoAlert = 'Your idea will be shared with your team'
            } else if (prefStore.autoShare === shareMode.dontShare){
                store.infoAlert = 'Your idea will not automatically be public to your team'
            } else if(prefStore.autoShare === shareMode.shareWithAdmins && Object.keys(prefStore.teamAdmins).length === 1 && Object.keys(prefStore.teamAdmins)[0] === authUser.uid){
                store.infoAlert = 'Your idea will not automatically be public to your team'
            }      
        })
        window.setTimeout(() => {
            store.infoAlert = undefined
        }, 5000)
        this.setState({ isFirstime: true })
        if(this.state.existingIdeaKey) {
            store.unloadIdea(this.state.existingIdeaKey)
            messageStore.unloadMessages(this.state.existingIdeaKey)
            store.unloadSketches(this.state.existingIdeaKey)
        }
        store.flushCurrentIdea()
        store.theIdeaStatus = 200

        var newIdeaKey = store.addIdea(authUser)
        Logger.trackEvent('newIdeaSaved', 'ideaKey', newIdeaKey)
        this.setState({existingIdeaKey: newIdeaKey})

        const { replace } = routingStore
        replace('/idea/'+newIdeaKey+ '/edit')
    }
    handleDelete() {
        var ideaKey = this.state.existingIdeaKey
        Logger.trackEvent('deleteIdea', 'ideaKey', ideaKey)
        this.props.stores.store.deleteIdea(ideaKey)
        this.doClose()
    }
    onNameChange(text) {          this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'name', text) }
    onDescriptionChange(text) {   this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'description', text) }
    onNeedChange(text) {          this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'need', text) }
    onImageTextChange(text) {     this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'imageText', text) }
    onSketchTextChange(text) {    this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'sketchText', text) }
    onAttachmentTextChange(text) {this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'attachmentText', text) }
    onTagChange(tags)
        {
            if (tags !== undefined){
                let tagsList = []
                for(let x=0; x < tags.length; x++){
                    tagsList[x] = tags[x].value
                }

                if (tags.length === 0){
                    this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'tags', tagsList)
                }
                else if (tags[tags.length-1].value.length <= 50){
                    this.props.stores.store.updateIdeaProp(this.state.existingIdeaKey, 'tags', tagsList)
                }
                else {
                    this.setState({
                        longCharWarning : true,
                        })
                    setTimeout(() => {
                        this.setState({
                            longCharWarning : false,
                        })
                    },3000)
                }
            }
        }
    onMoreDescriptionChange(value) {
        this.props.stores.store.updateIdeaProp(
            this.state.existingIdeaKey,
            'moreDescription',
            value,
            false, //DO NOT UPDATE TIMESTAMP
        )
    }
    onSketchChange(jsonSketch, pngSketchString){
        const {stores} = this.props
        const {store} = stores
        let new_csum = helpers.checksum(jsonSketch)
        let old_csum = store.sketchChecksum

        if(new_csum !== old_csum){
            // store.sketch = jsonSketch
            store.newSketch(jsonSketch, pngSketchString, this.state.existingIdeaKey)
        }
    }
    onDeleteSketch(){
        this.props.stores.store.removeSketch(this.state.existingIdeaKey, false)
        Logger.trackEvent('onDeleteSketch', 'ideaKey', this.state.existingIdeaKey)
    }
    onAddTeamAsMember(newTeam){
        const {stores} = this.props
        const {teamStore, store} = stores
        teamStore.assignTeamToIdea(newTeam, this.state.existingIdeaKey, store.theIdea)
        Logger.trackEvent('onAddTeamAsMember', 'ideaKey', this.state.existingIdeaKey)
    }
    onAddTeamMember(email, fullName){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store

        store.addMemberToIdea(
            this.state.existingIdeaKey,
            email,
            fullName,
            theIdea.owner,
        )
        Logger.trackEvent('onAddTeamMember', 'ideaKey', this.state.existingIdeaKey)
    }
    onAddResponsible(responsibleEmail, responsibleName){
        const {stores} = this.props
        const {store} = stores

        store.addResponsible(
            this.state.existingIdeaKey,
            responsibleEmail,
            responsibleName,
        )
        Logger.trackEvent('onAddTeamMember', 'ideaKey', this.state.existingIdeaKey)
    }
    onRemoveTeamMember(memberEmail, sharedDeleteType){
        // console.log('onRemoveTeamMember',memberEmail)
        const {stores} = this.props
        const {store} = stores
        Logger.trackEvent('onRemoveTeamMember', 'ideaKey', this.state.existingIdeaKey)
        store.removeMemberFromIdeaTeam(memberEmail, this.state.existingIdeaKey, sharedDeleteType)
    }
    onRemoveTeamFromIdea(teamId){
        // console.log('onRemoveTeamFromIdea',teamId)
        const {stores} = this.props
        const {store, teamStore} = stores
        Logger.trackEvent('onRemoveTeamFromIdea', 'teamId', teamId)
        teamStore.removeTeamFromIdea(teamId, this.state.existingIdeaKey, store.theIdea)
    }
    onLeaveTeam(sharedDeleteType){
        // console.log('onLeaveTeam',this.props.stores.authStore.authUser().email)
        const {stores} = this.props
        const {store, routingStore} = stores
        const {push} = routingStore
        if(store.sharedIdeas.hasOwnProperty(this.state.existingIdeaKey)){
            delete store.sharedIdeas[this.state.existingIdeaKey]
        }
        store.removeMemberFromIdeaTeam(this.props.stores.authStore.authUser().email, this.state.existingIdeaKey, sharedDeleteType)
        Logger.trackEvent('onLeaveTeam')
        push('/ideas')
    }
    onNewMessage(newMessage){
        const {stores} = this.props
        const {store, messageStore} = stores
        messageStore.newMessage(newMessage, this.state.existingIdeaKey, store.theIdea)
        Logger.trackEvent('onNewMessage','length',newMessage.length)
    }
    onNewImage(url, bucket, fullPath, origFileName, index){
        const {stores} = this.props
        const {store} = stores
        if(index === -1){
            store.theIdea.imageUrl_bucket = bucket
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageUrl_bucket', bucket)
            store.theIdea.imageUrl_fullPath = fullPath
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageUrl_fullPath', fullPath)
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageOrigFileName', origFileName)
            store.theIdea.imageUrl = url
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageUrl', url)
        }else if(index === -2){
            store.theIdea.needImageUrl_bucket = bucket
            store.updateIdeaProp(this.state.existingIdeaKey, 'needImageUrl_bucket', bucket)
            store.theIdea.needImageUrl_fullPath = fullPath
            store.updateIdeaProp(this.state.existingIdeaKey, 'needImageUrl_fullPath', fullPath)
            store.updateIdeaProp(this.state.existingIdeaKey, 'needOrigFileName', origFileName)
            store.theIdea.needImageUrl = url
            store.updateIdeaProp(this.state.existingIdeaKey, 'needImageUrl', url)
        }else{
            store.theIdea.imageUrls_bucket[index] = bucket
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageUrls_bucket', store.theIdea.imageUrls_bucket)
            store.theIdea.imageUrls_fullPath[index] = fullPath
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageUrls_fullPath', store.theIdea.imageUrls_fullPath)
            store.theIdea.imageOrigFileNames[index] = origFileName
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageOrigFileNames', store.theIdea.imageOrigFileNames)
            store.theIdea.imageUrls[index] = url
            store.updateIdeaProp(this.state.existingIdeaKey, 'imageUrls', store.theIdea.imageUrls)
        }
        Logger.trackEvent('onNewImage','origFileName',origFileName)
    }
    onImageRejected(file){
        const {stores} = this.props
        const {store} = stores
        Logger.trackEvent('imageRejected', 'file', file)
        store.errorAlert = 'Image file '+file+' not PNG or JPEG format. Please try another image.'
        window.setTimeout(() => { store.errorAlert = undefined }, 5000)
    }
    saveRating(value, whichField){
        const {stores} = this.props
        const {store} = stores
        store.updateIdeaProp(this.state.existingIdeaKey, whichField, value)
    }
    onNewAttachment(url, bucket, fullPath, origFileName, index){
        const {stores} = this.props
        const {store} = stores
        store.theIdea.attachmentUrls[index] = url
        store.updateIdeaProp(this.state.existingIdeaKey, 'attachmentUrls', store.theIdea.attachmentUrls)
        store.theIdea.attachmentUrls_bucket[index] = bucket
        store.updateIdeaProp(this.state.existingIdeaKey, 'attachmentUrls_bucket', store.theIdea.attachmentUrls_bucket)
        store.theIdea.attachmentUrls_fullPath[index] = fullPath
        store.updateIdeaProp(this.state.existingIdeaKey, 'attachmentUrls_fullPath', store.theIdea.attachmentUrls_fullPath)
        store.theIdea.attachmentOrigFileNames[index] = origFileName
        store.updateIdeaProp(this.state.existingIdeaKey, 'attachmentOrigFileNames', store.theIdea.attachmentOrigFileNames)
    }
    onAttachmentRejected(file){
        const {stores} = this.props
        const {store} = stores
        Logger.trackEvent('attachmentRejected', 'file', file)
        store.errorAlert = 'File '+file+' failed. Please try another file.'
        window.setTimeout(() => { store.errorAlert = undefined }, 5000)
    }
    handleImageDelete(index, e) {
        var thing = this
        let fullPath
        if(index === -1){
            fullPath = this.props.stores.store.theIdea.imageUrl_fullPath
        }else if(index === -2){
            fullPath =  this.props.stores.store.theIdea.needImageUrl_fullPath
        }else{
            fullPath = this.props.stores.store.theIdea.imageUrls_fullPath[index]
        }

        Logger.trackEvent('ImageDelete', thing.state.existingIdeaKey, fullPath)

        firebase.storage().ref().child(fullPath).delete().then(function () {
            // File deleted successfully
            if(index === -1){
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageUrl',
                    null,
                )
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageUrl_bucket',
                    null,
                )
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageUrl_fullPath',
                    null,
                )
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageOrigFileName',
                    null,
                )
            }else if(index === -2){
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'needImageUrl',
                    null,
                )
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'needImageUrl_bucket',
                    null,
                )
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'needImageUrl_fullPath',
                    null,
                )
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'needOrigFileName',
                    null,
                )
            }else{
                thing.props.stores.store.theIdea.imageUrls.splice(index, 1)
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageUrls',
                    thing.props.stores.store.theIdea.imageUrls,
                )
                thing.props.stores.store.theIdea.imageUrls_bucket.splice(index, 1)
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageUrls_bucket',
                    thing.props.stores.store.theIdea.imageUrls_bucket,
                )
                thing.props.stores.store.theIdea.imageUrls_fullPath.splice(index, 1)
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageUrls_fullPath',
                    thing.props.stores.store.theIdea.imageUrls_fullPath,
                )
                thing.props.stores.store.theIdea.imageOrigFileNames.splice(index, 1)
                thing.props.stores.store.updateIdeaProp(
                    thing.state.existingIdeaKey,
                    'imageOrigFileNames',
                    thing.props.stores.store.theIdea.imageOrigFileNames,
                )
            }
        }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.error(error)
        })
        Logger.trackEvent('handleImageDelete', 'index', index)
        e.stopPropagation()
    }
    handleAttachmentDelete(index) {
        var thing = this
        let fullPath

        fullPath = this.props.stores.store.theIdea.attachmentUrls_fullPath[index]

        Logger.trackEvent('AttachmentDelete', thing.state.existingIdeaKey, fullPath)

        firebase.storage().ref().child(fullPath).delete().then(function () {
            // File deleted successfully
            thing.props.stores.store.theIdea.attachmentUrls.splice(index, 1)
            thing.props.stores.store.updateIdeaProp(
                thing.state.existingIdeaKey,
                'attachmentUrls',
                thing.props.stores.store.theIdea.attachmentUrls,
            )
            thing.props.stores.store.theIdea.attachmentUrls_bucket.splice(index, 1)
            thing.props.stores.store.updateIdeaProp(
                thing.state.existingIdeaKey,
                'attachmentUrls_bucket',
                thing.props.stores.store.theIdea.attachmentUrls_bucket,
            )
            thing.props.stores.store.theIdea.attachmentUrls_fullPath.splice(index, 1)
            thing.props.stores.store.updateIdeaProp(
                thing.state.existingIdeaKey,
                'attachmentUrls_fullPath',
                thing.props.stores.store.theIdea.attachmentUrls_fullPath,
            )
            thing.props.stores.store.theIdea.attachmentOrigFileNames.splice(index, 1)
            thing.props.stores.store.updateIdeaProp(
                thing.state.existingIdeaKey,
                'attachmentOrigFileNames',
                thing.props.stores.store.theIdea.attachmentOrigFileNames,
            )
        }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.error(error)
        })
        Logger.trackEvent('handleAttachmentDelete', 'index', index)
    }
    saveSketchLineWidth(value){
        this.props.stores.prefStore.lineWidth = value
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('saveSketchLineWidth', 'lineWidth', value)
    }
    saveSketchLineColor(color){
        this.props.stores.prefStore.lineColor = color.hex
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('saveSketchLineColor', 'lineColor', color.hex)
    }
    // onNewVideo(blob){
    //     var storageRef = firebase.storage().ref('ideas/ideasheet/videos/');
    //     var filename = helpers.guid()+'.webm'
    //     var videoRef = storageRef.child(filename);
    //
    //     videoRef.put(blob).then(snapshot => {
    //         console.log('Uploaded video file!')
    //         firebase.storage().ref('ideas/ideasheet/videos').child(filename).getDownloadURL().then(url => {
    //             this.props.stores.store.theIdea.videoUrl = url
    //         })
    //     })
    // }
    onToolChange(text, tool, id){
        this.props.stores.store.theIdea[tool][id] = text
        this.props.stores.store.updateIdeaProp(
            this.state.existingIdeaKey,
            tool,
            this.props.stores.store.theIdea[tool],
        )
        Logger.trackEvent('onToolChange', 'tool', tool)
    }
    renderTagsLayout(tagComponents, inputComponent) {
        return (
            <div onClick={() => {this.tagInput.focus()}}>
                <div>
                    <span className='tagTip'>
                        <ToolTip tipText='Tag your ideas to make them easier to ﬁnd and to sort. Usually 3-4 tags will be a good amount'>
                            <Glyphicon className='ideaTipColor' glyph='question-sign'/>
                        </ToolTip>
                    </span>
                    {tagComponents}
                    {inputComponent}
                </div>
            </div>
        )
    }
    openFullscreen(e, whichField, id){
        if(whichField === 'ideaImage'){
            this.setState({ isOpenIdea: true})
        }
        if(whichField === 'needImage'){
            this.setState({ isOpenNeed: true })
        }
        if(whichField === 'multipleImages'){
            this.setState({
                isOpenImage: true,
                imageId: id,
            })
        }
        Logger.trackEvent('openFullscreen', 'whichField', whichField)
        e.stopPropagation()
    }
    nextSlide(theIdea){
        Logger.trackEvent('nextSlide')
        if(theIdea.imageUrls.length > 1){
            return theIdea.imageUrls[(this.state.imageId + 1) % theIdea.imageUrls.length]
        }
    }
    previousSlide(theIdea){
        Logger.trackEvent('previousSlide')
        if(theIdea.imageUrls.length > 1){
            return theIdea.imageUrls[(this.state.imageId + theIdea.imageUrls.length - 1) % theIdea.imageUrls.length]
        }
    }
    renderGallery(that){
        Logger.trackEvent('renderGallery')
        setTimeout(() => {
            this.forceUpdate() //Makes gallery load again in order to scale images properly
        }, 300)
    }
    storeIdea(status){
        const {stores} = this.props
        const {routingStore, authStore, notificationStore, store} = stores
        const { push } = routingStore
        const {theIdea} = store

        store.storeTheIdea(this.state.existingIdeaKey, status).then((ideaKey) => {
            push('/idea/'+ ideaKey + '/view')
            store.infoAlert = 'Idea stored'
            notificationStore.createNotificationToTeamMembers(ideaKey, authStore.authUser().displayName + ' has stored this idea as "' + status + '"', theIdea.owner, toJS(theIdea.team), theIdea.responsible, null)
            window.setTimeout(() => {
                store.infoAlert = undefined
            }, 3000)
        })
        Logger.trackEvent('storeIdea', 'ideaKey', this.props.ideaKey)
    }
    renderImageFields(theIdea){
        const maxImages = 100
        let imageFields = []
        let currImgCount = theIdea.imageUrls.length<maxImages ? theIdea.imageUrls.length + 1 : theIdea.imageUrls.length
        for (let i = 0; i < currImgCount; i++) {
            let url = (theIdea.imageUrls.length>i) ? theIdea.imageUrls[i] : null
            imageFields.push(
                <div style={{width: 210+'px'}} className='col-xs-6 col-sm-5cols' key={i}>
                    <div className='thumbnail'>
                        <IdeaImageField
                            onNewImage={this.onNewImage.bind(this)}
                            onImageRejected={this.onImageRejected.bind(this)}
                            ideaKey= {this.props.params.ideaKey}
                            imageUrl={url}
                            theKey={i}
                            imageId={i}
                            isUpLoading= {theIdea.imageUrls_isUpLoading}
                            imageHeight={180}
                            fieldHeight={170}
                            handleImageDelete = {this.handleImageDelete.bind(this)}
                            fullscreenOption={this.openFullscreen.bind(this)}
                            whichField={'multipleImages'}
                        />
                    </div>
                </div>,
            )
        }
        return imageFields
    }
    checkToolContent(tool){
        var isFound = -1
        for (let i in tool) {
            if (tool[i] !== '') {
                isFound = 0
            }
        }
        if (isFound === 0) {
            return true
        }
        else return false
    }
    checkTimelineContent(tableArray){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea.hasOwnProperty(tableArray)) {
            if (theIdea[tableArray].length > 0){
                return true
            }
        }
        else return false
    }
    checkViabilityContent(costs, revenue, viability){
        let foundContent = -1
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea.hasOwnProperty(costs)) {
            if (theIdea[costs].length > 0){
                foundContent = 0
            }
        }
        if (theIdea.hasOwnProperty(revenue)) {
            if (theIdea[revenue].length > 0){
                foundContent = 0
            }
        }
        if (theIdea[viability] !== '') {
            foundContent = 0
        }
        if (foundContent === 0) {
            return true
        }
        else return false
    }
    renderAttachmentFields(theIdea){
        const maxAttachments = 100
        let attachmentFields = []
        let currAttCount = theIdea.attachmentUrls.length<maxAttachments ? theIdea.attachmentUrls.length + 1 : theIdea.attachmentUrls.length
        for (let i = 0; i < currAttCount; i++) {
            let url = (theIdea.attachmentUrls.length>i) ? theIdea.attachmentUrls[i] : null
            let filename = (theIdea.attachmentOrigFileNames.length>i) ? theIdea.attachmentOrigFileNames[i] : null
            attachmentFields.push(
                <div style={{marginBottom: 20+'px', height: 195+'px', width: 200+'px', minWidth: 185+'px'}} className='col-xs-3 col-sm-5cols' key={i}>
                    <div className='thumbnail'>
                        <IdeaAttachmentField
                            onNewAttachment={this.onNewAttachment.bind(this)}
                            onAttachmentRejected={this.onAttachmentRejected.bind(this)}
                            attachmentUrl={url}
                            origFileName={filename}
                            theKey={i}
                            showDropzone={true}
                            handleAttachmentDelete = {this.handleAttachmentDelete.bind(this)}
                        />
                    </div>
                </div>,
            )
        }
        return attachmentFields
    }
    setStage(stageNumber){
        this.props.stores.store.theIdea.currentStage = stageNumber
        this.props.stores.store.updateIdeaProp(
            this.state.existingIdeaKey,
            'currentStage',
            this.props.stores.store.theIdea.currentStage,
        )
    }
    setDueDate(dueDate){
        const format = 'DD-MM-YYYY'
        if (dueDate !== '' && dueDate !== null){
            let date = dueDate.format(format)
            let myDate=date.split("-")
            var newDate=myDate[1]+"/"+myDate[0]+"/"+myDate[2]
            this.props.stores.store.theIdea.dueDate = new Date(newDate).getTime()
            this.props.stores.store.addDueDateToDb(this.state.existingIdeaKey, this.props.stores.store.theIdea.dueDate)
        }
        else this.props.stores.store.theIdea.dueDate = ''
        this.props.stores.store.updateIdeaProp(
            this.state.existingIdeaKey,
            'dueDate',
            this.props.stores.store.theIdea.dueDate,
        )
    }
    focusOnTitle(){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        let titleFieldId = document.getElementById('titleFieldId')
        if(this.state.isFirstime === true ) {
            if(titleFieldId){
                if(theIdea.name === '' || theIdea.name === null || theIdea.name === undefined){
                    setTimeout(()=> {
                     document.getElementById('titleFieldId').focus()
                    }, 0.1)
                    titleFieldId.addEventListener("blur", () => {
                        this.setState({ isFirstime: false })
                    })
                }
            }
        }
    }
    scrollToBottom() {
        const commentList = document.getElementById('ideaPageComment')
        if(commentList !== null) {
            commentList.scrollTop = commentList.scrollHeight
        }
    }
    render() {
        const {stores} = this.props
        const {store, authStore, routingStore, toolStore, prefStore, messageStore} = stores
        const {theIdea, theIdeaStatus} = store
        const {push, location} = routingStore
        const {messages} = messageStore
        var theUser = authStore.authUser()
        // const onFreePlan = authStore.onFreePlan()
        // const userProfile = authStore.userProfile()
        const userPrimaryTeam = authStore.primaryTeam()
        const userAssignTeamToIdeas = authStore.auth.teamList
        let userId = null

        if (theUser !== undefined){
            userId = theUser.uid
        }
        var maxCollaborators = 100
        var day = {}
        let chosenDay = ''
        let canView = false
        if (theIdea){
            if(theIdea.dueDate){
                var timestampDue = new Date(theIdea.dueDate)
                chosenDay = timestampDue.getDate() + '-' + (timestampDue.getMonth()+1) + '-' + timestampDue.getFullYear()
                day = moment(timestampDue.getDate() + '-' + (timestampDue.getMonth()+1) + '-' + timestampDue.getFullYear(), 'DD-MM-YYYY')
            }
            else {
                chosenDay = theIdea.dueDate
                day = null
            }
        }
        let tags = []
        let defaultTags = []
        let loadedTeam = prefStore.ideaTeam
        let loadedAllTools = {}
        let loadedToolNames = []
        let loadedToolShowname = {}

        for(let y = 0; y < this.state.loadedTeamTags.length; y++){
            defaultTags.push({value: this.state.loadedTeamTags[y], label: this.state.loadedTeamTags[y]})
        }
        // if(userProfile && userProfile.plan_details){
        //     maxCollaborators = userProfile.plan_details.collaborators_per_idea
        //     maxImages = userProfile.plan_details.images_per_idea
        //     maxAttachments = userProfile.plan_details.attachments_per_idea
        // }

        this.focusOnTitle()

        if(theIdeaStatus===0){
            return null
        }else if(theIdeaStatus===403){
            Logger.trackEvent('403', location.pathname, helpers.mangleEmail(theUser.email))
            window.onpopstate = null
            push('/forbidden')
            return null
        }else if(theIdeaStatus===404){
            Logger.trackEvent('404', location.pathname, helpers.mangleEmail(theUser.email))
            window.onpopstate = null
            push('/notfound')
            return null
        }else if(theIdeaStatus===500){
            window.onpopstate = null
            push('/error')
            return null
        }else if(theIdeaStatus===200){
            window.onpopstate = this.onBackButtonEvent.bind(this)
        }
        if(theIdea.tags.length > 0){
            for(let x = 0; x < theIdea.tags.length; x++){
                tags.push({value: theIdea.tags[x], label: theIdea.tags[x]})
            }
        }
        if(theIdea !== undefined && theIdea.hasOwnProperty('status')){
            push('/idea/'+ this.state.existingIdeaKey + '/view')
        }
        let lastUpdated = null
        if (theIdea.lastUpdated){
            lastUpdated = moment(theIdea.lastUpdated).fromNow()
        }
        if(theIdea !== undefined){
            if(theIdea.hasOwnProperty('team')){
                theIdea.team.forEach(teamMember => {
                    if(teamMember.hasOwnProperty('userId')){
                        if(teamMember.userId === theUser.uid){
                            canView = true
                        }
                    }
                })
            }
            if(theIdea.owner === theUser.email){
                canView = true
            }
            if(theIdea.hasOwnProperty('responsible') && theIdea.responsible.userId === theUser.uid){
                canView = true
            }
            if (canView === false && lastUpdated !== null){
                push('/forbidden')
            }
        }
        if(theIdea !== undefined){
            for(let aTool of this.state.loadedTeamTools){
                let key = Object.keys(aTool)[0]
                loadedToolNames.push(key)
                loadedAllTools[key] = aTool[key].tools
                loadedToolShowname[key] = aTool[key].showName
            }
            for (const tool of loadedToolNames) {
                //TODO: we should never update the store from the render method
                if (!theIdea.hasOwnProperty(tool)) {
                    store.theIdea[tool] = {}
                }
            }
        }
        var isOwner = (theUser.email === theIdea.owner) ? true : false
        var ago = ''
        moment.locale('da')
        if (theIdea.hasOwnProperty('timestamp'))
            ago = moment(theIdea.timestamp).format('lll')
        return (

            <div className='ideaPageContainerOpen'>
                <Row id='ideaDescription'>
                    <div>
                        <div className='ideaDivWrapper'>
                            <h3 className='ideaTitle'>The title of your idea</h3>
                        </div>
                         <div className='ideaEmptyGap'>
                        </div>
                    </div>
                    <Col lg={6} sm={6} xs={12}>
                        <OneLineTextField
                            ref={(input) => this.titleField = input}
                            id={'titleFieldId'}
                            name={theIdea.name}
                            limit={60}
                            onChange={this.onNameChange.bind(this)}
                            placeholder='The title of your idea'
                        />
                    </Col>
                    <Col className='IdeaPageSelector' lg={5} sm={4} xs={11}>
                            <Select.Creatable
                                multi={true}
                                placeholder={'Add tags...'}
                                options={defaultTags}
                                closeOnSelect={false}
                                style={SelectStyle}
                                onChange={this.onTagChange.bind(this)}
                                promptTextCreator={(label) => 'Create tag "' + label + '"'}
                                value={tags}
                            />
                        <div>
                            {this.state.longCharWarning &&
                                <strong style={{color: 'red'}}>Tag is exceeding 50 character limit!</strong>
                            }
                        </div>
                    </Col>
                    <Col lg={1} sm={2} xs={1} className='tagVidCol' style={{paddingTop: '1px', marginLeft: '-15px', paddingLeft: '0px', width: '10px'}}>
                            <VideoModal
                                videoTitle='Tag your Idea'
                                videoURL='https://www.youtube.com/watch?v=VnLjJ1ESk1U'
                            />
                    </Col>
                </Row>
                <small>by {theIdea.ownerName} ({theIdea.owner}) on {ago}</small>
                <Panel eventKey='3'>
                    <Row>
                        <Col sm={6}>
                            <div>
                                <div className='ideaDivWrapper'>
                                    <h3>Describe your idea
                                        <div className='ideaTip'>
                                        <ToolTip tipText='Describe your idea. Be sharp in the value of the idea and why it is a good idea. Only the first 500 characters will be shown in the presentation slide.'>
                                        <Glyphicon glyph='question-sign' className='tipColor'/>
                                        </ToolTip>
                                    </div>
                                    </h3>
                                </div>

                            </div>
                            <PoorTextField
                                description={theIdea.description}
                                onChange={this.onDescriptionChange.bind(this)}
                                label=''
                                placeholder='In 500 characters or less'
                            />
                        </Col>
                        <Col sm={6}>
                            <div>
                                <div className='ideaDivWrapper'>
                                    <h3>Show your idea
                                        {/*<div className='ideaTip'>
                                         <ToolTip tipText='Sometimes its easier to show an idea in a picture. So if you have one… Put it here.'>
                                        <Glyphicon glyph='question-sign' className='tipColor'/>
                                        </ToolTip>
                                        </div>*/}
                                        <VideoModal className='ideaTip'
                                            videoTitle='Show your idea'
                                            videoURL='https://www.youtube.com/watch?v=86vhmIt_f10'
                                        />
                                    </h3>
                                </div>
                            </div>
                            <IdeaImageField
                                onNewImage={this.onNewImage.bind(this)}
                                onImageRejected={this.onImageRejected.bind(this)}
                                handleImageDelete = {this.handleImageDelete.bind(this)}
                                ideaKey= {this.props.params.ideaKey}
                                imageUrl={theIdea.imageUrl}
                                isUpLoading= {theIdea.imageUrl_isUpLoading}
                                theKey={-1}
                                fieldHeight={145}
                                imageHeight={280}
                                fullscreenOption={this.openFullscreen.bind(this)}
                                whichField={'ideaImage'}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <div>
                                <div className='ideaDivWrapper'>
                                    <h3>Describe the need or problem
                                        <div className='ideaTip'>
                                        <ToolTip tipText='Describe the need you are trying to address or the problem you are trying to solve. Only the first 500 characters will be shown in the presentation slide.'>
                                        <Glyphicon glyph='question-sign' className='tipColor'/>
                                        </ToolTip>
                                        </div>
                                    </h3>
                                </div>

                            </div>
                            <PoorTextField
                                description={theIdea.need}
                                onChange={this.onNeedChange.bind(this)}
                                label=''
                                placeholder='In 500 characters or less'
                            />
                        </Col>
                        <Col sm={6}>
                            <div>
                                <div className='ideaDivWrapper'>
                                    <h3>Show the need or problem
                                        <div className='ideaTip'>
                                        <ToolTip tipText='Sometimes its easier to understand an idea, if you have a good, visual example of the need or problem you are trying to solve… Put that image here.'>
                                        <Glyphicon glyph='question-sign' className='tipColor'/>
                                        </ToolTip>
                                        </div>
                                    </h3>

                                </div>

                            </div>
                            <IdeaImageField
                                onNewImage={this.onNewImage.bind(this)}
                                onImageRejected={this.onImageRejected.bind(this)}
                                handleImageDelete = {this.handleImageDelete.bind(this)}
                                ideaKey= {this.props.params.ideaKey}
                                imageUrl={theIdea.needImageUrl}
                                isUpLoading= {theIdea.needImageUrl_isUpLoading}
                                theKey={-2}
                                imageHeight={280}
                                fieldHeight={145}
                                fullscreenOption={this.openFullscreen.bind(this)}
                                whichField={'needImage'}
                            />
                        </Col>
                    </Row>
                </Panel>
                <Panel id='ideaAddDetails' header={<h2>Add more details to your idea</h2>} eventKey='4'>
                    <Tab.Container defaultActiveKey='image' id='more-details-tabs'>
                        <Row className='clearfix'>
                            <Col lgHidden mdHidden>
                                <Nav bsStyle='tabs'>
                                    <NavItem eventKey='image'>
                                    {theIdea.imageUrls.length > 0 &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Images
                                    </NavItem>
                                    {/* <NavItem eventKey='sketch'>
                                    {(theIdea.gotSketch !== '' && theIdea.gotSketch !== undefined) &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Sketch
                                    </NavItem> */}
                                    <NavItem eventKey='attachment'>
                                    {theIdea.attachmentUrls.length > 0 &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Attachments
                                    </NavItem>
                                    <NavItem eventKey='text'>
                                    {(theIdea.moreDescription !== '' && theIdea.moreDescription !== '<p><br></p>') &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Text
                                    </NavItem>
                                </Nav>
                            </Col>
                            <Col xsHidden smHidden sm={3}>
                                <Nav bsStyle='tabs' stacked>
                                    <NavItem eventKey='image'>
                                    {theIdea.imageUrls.length > 0 &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Add images or graphics
                                    </NavItem>
                                    {/* <NavItem eventKey='sketch'>
                                    {(theIdea.gotSketch !== '' && theIdea.gotSketch !== undefined) &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Make a sketch
                                    </NavItem> */}
                                    <NavItem eventKey='attachment'>
                                    {theIdea.attachmentUrls.length > 0 &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Add attachments
                                    </NavItem>
                                    <NavItem eventKey='text'>
                                    {(theIdea.moreDescription !== '' && theIdea.moreDescription !== '<p><br></p>') &&
                                     <Glyphicon glyph='ok' className='contentIndicator'/>
                                    }
                                        Add more text
                                    </NavItem>
                                </Nav>
                            </Col>
                            <Col sm={9}>
                                <Tab.Content animation>
                                    <Tab.Pane eventKey='image'>
                                        <div>
                                            <div className='ideaImage'>
                                                <div className='ideaDivWrapper'>
                                                    <ControlLabel>Add an Image to your idea:</ControlLabel>
                                                </div>
                                            </div>
                                            <Row>
                                                {this.renderImageFields(theIdea)}
                                                {/* {(onFreePlan && theIdea.imageUrls.length===maxImages) &&
                                                    <div className='col-xs-6'>
                                                        <LinkContainer to='/plans'>
                                                            <Button bsStyle='link'>
                                                                <Glyphicon glyph='circle-arrow-up'/> UPGRADE to add more images
                                                            </Button>
                                                        </LinkContainer>
                                                    </div>
                                                } */}
                                            </Row>
                                            <OneLineTextField
                                                name={theIdea.imageText}
                                                limit={100}
                                                onChange={this.onImageTextChange.bind(this)}
                                                placeholder='Describe the image'
                                            />
                                        </div>
                                    </Tab.Pane>
                                    {/* <Tab.Pane eventKey='sketch'>
                                        <IdeaSketchField
                                            onChange={this.onSketchChange.bind(this)}
                                            sketch={toJS(sketch)}
                                            lineColor={prefStore.lineColor}
                                            deleteSketch={this.onDeleteSketch}
                                            sketchUrl={theIdea.gotSketch}
                                            lineWidth={prefStore.lineWidth}
                                            checksum={sketchChecksum}
                                            saveColor = {this.saveSketchLineColor.bind(this)}
                                            saveWidth = {this.saveSketchLineWidth.bind(this)}
                                        />
                                        <OneLineTextField
                                            name={theIdea.sketchText}
                                            limit={100}
                                            onChange={this.onSketchTextChange.bind(this)}
                                            placeholder='Describe the sketch'
                                        />
                                    </Tab.Pane> */}
                                    <Tab.Pane eventKey='attachment'>
                                        <div>
                                            <ControlLabel style={{height: 50+'px'}}>Add a File attachment to your idea:</ControlLabel>
                                            <Row>
                                                {this.renderAttachmentFields(theIdea)}
                                                {/* {(onFreePlan && theIdea.attachmentUrls.length===maxAttachments) &&
                                                    <Col xs={6}>
                                                        <LinkContainer to='/plans'>
                                                            <Button bsStyle='link'>
                                                                <Glyphicon glyph='circle-arrow-up'/> UPGRADE to add more files
                                                            </Button>
                                                        </LinkContainer>
                                                    </Col>
                                                } */}
                                                <VideoModal
                                                    videoTitle='Show your idea'
                                                    videoURL='https://www.youtube.com/watch?v=86vhmIt_f10'
                                                />
                                            </Row>
                                            <OneLineTextField
                                                name={theIdea.attachmentText}
                                                limit={100}
                                                onChange={this.onAttachmentTextChange.bind(this)}
                                                placeholder='Describe the attachment'
                                            />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey='text'>
                                        <RichTextField
                                            description={theIdea.moreDescription}
                                            onChange={this.onMoreDescriptionChange.bind(this)}
                                            label='Describe your idea:'
                                            placeholder='Describe your idea in all the details your heart desires'
                                        />
                                    </Tab.Pane>
                                    {/*<Tab.Pane eventKey='video'>
                                        <IdeaVideoField
                                            onNewVideo={this.onNewVideo.bind(this)}
                                            videoUrl={theIdea.videoUrl}
                                        />
                                        <OneLineTextField
                                            name={theIdea.videoText}
                                            onChange={this.onVideoTextChange.bind(this)}
                                            placeholder='Describe the video'
                                        />
                                    </Tab.Pane>*/}
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Panel>
                <div id='ideaStage'>
                    {this.state.loadedTeamStages.length > 0 &&
                        <div>
                            <span className='activeText'>Active</span>
                            <IdeaStage
                                stage={theIdea.currentStage}
                                setStage={this.setStage.bind(this)}
                                stageNames={this.state.loadedTeamStages}
                                cursor='pointer'
                            />
                            <span className='storedText'>Stored
                                <VideoModal
                                    videoTitle='Idea Storage'
                                    videoURL='https://www.youtube.com/watch?v=nEuxPQ3oRDY'
                                />
                            </span>
                            <div className='statusContainer'>
                                <div onClick={() => this.storeIdea('Accepted', theUser)} className='statusAccepted'>Accepted</div>
                                <div onClick={() => this.storeIdea('Rejected', theUser)} className='statusRejected'>Rejected</div>
                            </div>
                        </div>
                    }
                    <IdeaDueDate
                        setDueDate={this.setDueDate.bind(this)}
                        dueDate={chosenDay}
                        selectedDueDate={day}
                    />
                </div>
                <Panel id='ideaRating' header={
                    <h2>Rate the Effort and Impact of your idea
                        <VideoModal
                            videoTitle='Rate your idea'
                            videoURL='https://www.youtube.com/watch?v=P2wCZLfPNes'
                        />
                    </h2>} eventKey='101'>
                <div style={{fontSize: 17+'px'}}>Give a rating to the idea that might help understand if the idea is worth investing in.</div>
                    <IdeaRatingField
                        effortRating={theIdea.effortRating}
                        impactRating={theIdea.impactRating}
                        effortGuideline={toolStore.effortGuideline}
                        impactGuideline={toolStore.impactGuideline}
                        onChange={this.saveRating.bind(this)}
                    >
                        <RecommendationLabel
                            effortRating={theIdea.effortRating}
                            impactRating={theIdea.impactRating}
                        />
                    </IdeaRatingField>
                </Panel>
                <Panel id='ideaCollaboration' header={<h2>Share your idea with others</h2>} eventKey='5000'>
                    <IdeaSharingField
                        team={theIdea.team}
                        maxCollaborators={maxCollaborators}
                        onAddTeamMember={this.onAddTeamMember.bind(this)}
                        onAddResponsible={this.onAddResponsible.bind(this)}
                        onAddTeamAsMember={this.onAddTeamAsMember.bind(this)}
                        isOwner={isOwner}
                        userId={userId}
                        responsible={theIdea.responsible}
                        teamAdminsList={prefStore.teamAdmins}
                        primaryTeam={userPrimaryTeam}
                        ideaTeamOwners={loadedTeam}
                        ideaTeamKey={theIdea.teamId}
                        userMail={theUser.email}
                        fetchedTeams={userAssignTeamToIdeas}
                        onLeaveTeam={this.onLeaveTeam.bind(this)}
                        onRemoveTeamMember={this.onRemoveTeamMember.bind(this)}
                        onRemoveTeamFromIdea={this.onRemoveTeamFromIdea.bind(this)}
                    />
                    {/* {(onFreePlan && theIdea.team && theIdea.team.length===maxCollaborators) &&
                        <div className='row'>
                            <LinkContainer to='/plans'>
                                <Button className='ideaUpgrade' bsStyle='link'>
                                    <Glyphicon glyph='circle-arrow-up'/> UPGRADE to add more collaborators
                                </Button>
                            </LinkContainer>
                        </div>
                    } */}
                </Panel>
                <Panel header={<h2>Discuss  <VideoModal
                                 videoTitle='Rate your idea'
                                 videoURL='https://www.youtube.com/watch?v=KLe9ds7uGb4'
                            /></h2>} eventKey='6000'>
                    <div className='ideaPageComment' id='ideaPageComment' >
                        <CommentSection className='commentSection'
                            messages={messages}
                            userName={theUser.displayName}
                            userPhotoURL={theUser.photoURL} viewIdeaPageContainerOpen
                        />
                    </div>
                    <ChatEntry className='chatEntry'
                        onNewMessage={this.onNewMessage.bind(this)}
                        userName={theUser.displayName}
                        isIdeaPage={true}
                    />
                </Panel>
                {toolStore.toolOrder.length>0 &&
                    <Panel id='ideaTools' header={<h2>Strengthen your idea</h2>} eventKey='105'>
                        <Tab.Container defaultActiveKey={toolStore.toolOrder[0]} id='tools-tabs'>
                            <Row className='clearfix'>
                                <Col lgHidden mdHidden>
                                    <Nav bsStyle='tabs'>

                                        {loadedToolNames.map((majorTool, index) =>
                                            <NavItem eventKey={majorTool} key={majorTool}>
                                             {this.checkToolContent(theIdea[majorTool]) > 0 &&
                                                 <Glyphicon glyph='ok' className='contentIndicator'/>
                                             }

                                                {loadedToolShowname[majorTool]}
                                            </NavItem>,
                                        )}
                                        <NavItem eventKey='timeline'>
                                        {this.checkTimelineContent('timelineRows') &&
                                            <Glyphicon glyph='ok' className='contentIndicator'/>
                                        }
                                            Timeline
                                        </NavItem>
                                        <NavItem eventKey='viability'>
                                        {this.checkViabilityContent('costRows', 'revenueRows', 'viabilityText') &&
                                            <Glyphicon glyph='ok' className='contentIndicator'/>
                                        }
                                            Economic Viability
                                        </NavItem>
                                    </Nav>
                                </Col>
                                <Col xsHidden smHidden sm={3}>
                                    <Nav bsStyle='tabs' stacked>
                                        {loadedToolNames.map((majorTool, index) =>
                                            <NavItem eventKey={majorTool} key={majorTool}>
                                            {this.checkToolContent(theIdea[majorTool]) &&
                                                <Glyphicon glyph='ok' className='contentIndicator'/>
                                            }
                                            {loadedToolShowname[majorTool]}
                                            </NavItem>,
                                        )}
                                        <NavItem eventKey='timeline'>
                                        {this.checkTimelineContent('timelineRows') &&
                                            <Glyphicon glyph='ok' className='contentIndicator'/>
                                        }
                                            Timeline
                                        </NavItem>
                                        <NavItem eventKey='viability'>
                                        {this.checkViabilityContent('costRows', 'revenueRows', 'viabilityText') &&
                                            <Glyphicon glyph='ok' className='contentIndicator'/>
                                        }
                                            Economic Viability
                                        </NavItem>
                                    </Nav>
                                </Col>
                                <Col sm={9}>
                                    <Tab.Content animation>
                                        {loadedToolNames.map((majorTool) =>
                                            <Tab.Pane eventKey={majorTool} key={majorTool}>
                                                {theIdea[majorTool] && loadedAllTools[majorTool].map((theTool) =>
                                                    <PoorTextField
                                                        id={theTool.varName}
                                                        key={theTool.varName}
                                                        tool={majorTool}
                                                        description={theIdea[majorTool][theTool.varName]}
                                                        onChange={this.onToolChange.bind(this)}
                                                        placeholder={theTool.placeholder}
                                                        label={theTool.title}
                                                    />,
                                                )}
                                            </Tab.Pane>,
                                        )}
                                        <Tab.Pane eventKey='timeline'>
                                            <TimelineContainer ideaKey={this.state.existingIdeaKey} />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey='viability'>
                                            <ViabilityContainer ideaKey={this.state.existingIdeaKey} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Panel>
                }
                <div className='predo-bottom-bar'/>
                {this.state.isOpenImage &&
                    <Lightbox
                        imageTitle={theIdea.imageOrigFileNames[this.state.imageId]}
                        onAfterOpen={this.renderGallery(this)}//Calls out forceUpdate that happens after some miliseconds
                        mainSrc={theIdea.imageUrls[this.state.imageId]}
                        nextSrc={this.nextSlide(theIdea)}
                        prevSrc={this.previousSlide(theIdea)}
                        animationDuration={500}
                        onCloseRequest={() => this.setState({ isOpenImage: false })}
                        onMovePrevRequest={() => this.setState({
                            imageId: (this.state.imageId + theIdea.imageUrls.length - 1) % theIdea.imageUrls.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            imageId: (this.state.imageId + 1) % theIdea.imageUrls.length,
                        })}
                    />
                }
                {this.state.isOpenIdea &&
                    <Lightbox
                        imageTitle={theIdea.imageOrigFileName}
                        onAfterOpen={this.renderGallery(this)}
                        mainSrc={theIdea.imageUrl}
                        onCloseRequest={() => this.setState({ isOpenIdea: false })}
                        onMovePrevRequest={() => this.setState({})}
                    />
                }
                {this.state.isOpenNeed &&
                    <Lightbox
                        imageTitle={theIdea.needOrigFileName}
                        onAfterOpen={this.renderGallery(this)}
                        mainSrc={theIdea.needImageUrl}
                        onCloseRequest={() => this.setState({ isOpenNeed: false })}
                        onMovePrevRequest={() => this.setState({})}
                    />
                }
            </div>
        )
    }
}

export default inject("stores")(observer(IdeaPage))


// WEBPACK FOOTER //
// ./src/containers/IdeaPage.js